import { Card, Input, SwitchInput, UploadImageCard } from "@";
import type { ProjectSettingsSectionProps } from "./types";
import { ProjectType } from "@/features/donations/projects/types.ts";

export const ProjectSettingsSection = ({
  register,
  watch,
  setValue,
  getValues,
  errors,
  show,
  isSubmitSuccessful,
  handleUpload,
  giftProjects,
  customerCampaign,
}: ProjectSettingsSectionProps) => {
  return (
    <Card title=" إعدادات المشروع">
      {/* images */}
      <div className={`${show ? "flex gap-5" : "mb-0"}`}>
        <UploadImageCard
          show={!show}
          title="صورة المشروع"
          success={isSubmitSuccessful}
          src={getValues("imageUrl") as string}
          star={!getValues("imageUrl")}
          error={(errors.image as { message?: string })?.message}
          upload={(file: File) => handleUpload(file, "image")}
        >
          <p className="text-gray-500 text-xs mb-2 mt-1 ps-3">يفضل استخدام صورة  (360px × 400px)</p>
          <Input
            star="no"
            style="mt-1"
            placeholder=" النص البديل للصورة (alt text)"
            error={errors.imageAlt}
            disabled={!!show}
            input={register("imageAlt")}
          />


        </UploadImageCard>

        <UploadImageCard
          show={!show}
          title="صورة الترخيص"
          success={isSubmitSuccessful}
          src={getValues("projectLicenceUrl") as string}
          error={(errors.projectLicence as { message?: string })?.message}
          upload={(file: File) => handleUpload(file, "projectLicence")}
        />
      </div>

      <Input
        star
        style="mb-5"
        disabled={!!show}
        type="date-range"
        labelA="تاريخ البداية"
        labelB="تاريخ النهاية"
        valueA={watch("startsFrom") as string}
        valueB={watch("endsTo") as string}
        inputA={register("startsFrom")}
        inputB={register("endsTo")}
        errorA={errors.startsFrom}
        errorB={errors.endsTo}
        changeA={(e: string) => setValue("startsFrom", e)}
        changeB={(e: string) => setValue("endsTo", e)}
      />

      <div className="grid gap-5 md:grid-cols-2">
        <Input
          style="mb-5"
          type="text"
          star={!watch("showProgressBar")}
          label="المبلغ المطلوب"
          error={errors.allRequiredAmount}
          disabled={!!show}
          input={register("allRequiredAmount")}
        />

        <Input
          star
          style="mb-5"
          type="text"
          label="إضافة تبرعات سابقة"
          error={errors.currentPaidAmount}
          disabled={!!show}
          input={register("currentPaidAmount")}
        />
      </div>

      <div className="mb-5 grid gap-5 md:grid-cols-2">
        <Input
          star
          type="select"
          list={giftProjects}
          value={watch("giftProjectId")}
          label="ربط المشروع باهداء"
          error={errors.giftProjectId}
          disabled={!!show}
          input={register("giftProjectId")}
        />

        <Input
          min={0}
          star
          type="number"
          label="الترتيب"
          disabled={!!show}
          error={errors.order}
          input={register("order")}
        />
      </div>

      <div className="mb-5 grid gap-2 md:grid-cols-2">
        <SwitchInput
          label="تفعيل الدفع السريع"
          disabled={!!show}
          checked={watch("isFastPaymentActive") as boolean}
          change={(value: boolean) => setValue("isFastPaymentActive", value)}
        />

        <SwitchInput
          disabled={!!show}
          label="إخفاء المشروع من المتجر"
          checked={watch("hideProjectFromStore") as boolean}
          change={(value: boolean) => setValue("hideProjectFromStore", value)}
        />

        {Number(watch("projectType")) !== ProjectType.Deduction && (
          <SwitchInput
            disabled={!!show}
            label="عرض في صفحة التبرع السريع"
            checked={watch("showForFastDonation") as boolean}
            change={(value: boolean) => setValue("showForFastDonation", value)}
          />
        )}

        <SwitchInput
          label=" تنبيه اكتمال المشروع"
          disabled={!!show}
          checked={watch("notifyWhenCompleted") as boolean}
          change={(value: boolean) => setValue("notifyWhenCompleted", value)}
        />

        <SwitchInput
          label="عرض مؤشر الانجاز"
          disabled={!!show}
          checked={watch("showProgressBar") as boolean}
          change={(value: boolean) => setValue("showProgressBar", value)}
        />

        <SwitchInput
          label="عرض في الصفحة الرئيسة"
          disabled={!!show || !!customerCampaign?.id}
          checked={watch("showOnHomePage") as boolean}
          change={(value: boolean) => setValue("showOnHomePage", value)}
        />

        <SwitchInput
          className="md:col-span-2"
          label=" تفعيل المؤثر البصري على نص العنوان"
          disabled={!!show}
          checked={watch("projectVisualEffect") as boolean}
          change={(value: boolean) => setValue("projectVisualEffect", value)}
        />

        {Number(watch("projectType")) !== ProjectType.Meal && (
          <SwitchInput
            className="md:col-span-2"
            label="المشروع نيابةً عن شخص آخر"
            disabled={!!show}
            checked={watch("isOnBehalfOnProject") as boolean}
            change={(value: boolean) => setValue("isOnBehalfOnProject", value)}
          />
        )}
      </div>

      {/* NotifyWhenCompleted */}
      {watch("notifyWhenCompleted") && (
        <div className="mb-5 grid gap-5 md:grid-cols-2">
          <div>
            <Input
              type="email"
              placeholder="البريد الالكتروني لتلقي الوارد *"
              error={errors.personEmailToNotify}
              disabled={!!show}
              input={register("personEmailToNotify")}
            />
          </div>
          <div>
            <Input
              placeholder="رقم الجوال لتلقي الرسائل *"
              error={errors.personPhoneToNotify}
              disabled={!!show}
              input={register("personPhoneToNotify")}
            />
          </div>
        </div>
      )}
    </Card>
  );
};
